import React from 'react';
import shortid from "shortid";
import {ValidationError} from "../../../apis/errors";

interface ValidationErrorMessageProps {
  fieldErrors: ValidationError[] | undefined;
  field: string;
  textColorClass?: string;
}

export const ValidationErrorMessages = (props: ValidationErrorMessageProps) => {
  const { fieldErrors, field, textColorClass } = props;
  return (
    <>
      {fieldErrors?.filter(fieldError => {
        return fieldError.field === field;
      }).map(fieldError => {
        return (<div className={`mt-1 text-xs ${textColorClass}`} key={shortid.generate()}>{ fieldError.message }</div>);
      })}
    </>
  );
};

ValidationErrorMessages.defaultProps = {
  textColorClass: 'text-danger'
}
